/* eslint-disable camelcase */
import moment from 'moment-timezone'

export class CampaignReportsHelper {
  static generateLinkedInDateRange(timeFrame, timezone) {
    const tz = timezone || moment.tz.guess()
    const now = moment.tz(tz)

    const linkedInRanges = {
      today: {
        startDate: now.clone().startOf('day'),
        endDate: now.clone().endOf('day'),
      },
      yesterday: {
        startDate: now.clone().subtract(1, 'day').startOf('day'),
        endDate: now.clone().subtract(1, 'day').endOf('day'),
      },
      this_week: {
        startDate: now.clone().startOf('isoWeek'),
        endDate: now.clone().endOf('day'),
      },
      this_month: {
        startDate: now.clone().startOf('month'),
        endDate: now.clone().endOf('day'),
      },
      last_7d: {
        startDate: now.clone().subtract(7, 'day').startOf('day'),
        endDate: now.clone().subtract(1, 'day').endOf('day'),
      },
      last_30d: {
        startDate: now.clone().subtract(30, 'day').startOf('day'),
        endDate: now.clone().subtract(1, 'day').endOf('day'),
      },
      last_90d: {
        startDate: now.clone().subtract(90, 'day').startOf('day'),
        endDate: now.clone().subtract(1, 'day').endOf('day'),
      },
      last_6m: {
        startDate: now.clone().subtract(6, 'month').startOf('day'),
        endDate: now.clone().subtract(1, 'day').endOf('day'),
      },
      last_12m: {
        startDate: now.clone().subtract(12, 'month').startOf('day'),
        endDate: now.clone().subtract(1, 'day').endOf('day'),
      },
    }

    let startDate, endDate

    if (timeFrame.id === 'custom') {
      startDate = moment.tz(timeFrame.startValue, tz).startOf('day')
      endDate = moment.tz(timeFrame.endValue, tz).endOf('day')
    } else {
      const range = linkedInRanges[timeFrame.id]
      if(range) {
        startDate = range.startDate
        endDate = range.endDate
      }
    }

    return {
      'dateRange.start.year': startDate.year(),
      'dateRange.start.month': startDate.month() + 1,
      'dateRange.start.day': startDate.date(),
      'dateRange.end.year': endDate.year(),
      'dateRange.end.month': endDate.month() + 1,
      'dateRange.end.day': endDate.date(),
    };

  }

  static sortLinkedInAnalyticsDescending(data) {
    return data.sort((a, b) => {
      const dateA = new Date(a.dateRange.start.year, a.dateRange.start.month - 1, a.dateRange.start.day)
      const dateB = new Date(b.dateRange.start.year, b.dateRange.start.month - 1, b.dateRange.start.day)
      return dateB - dateA
    });
  }

  static mergeLinkedInAdReports(adInsightsReport, adsDataReport) {
    return adInsightsReport.map(insight => {
      const pivotId = (Array.isArray(insight.pivotValues) && insight.pivotValues.length > 0) ? insight.pivotValues[0] : null
      const matchedAd = pivotId ? adsDataReport.find(ad => ad.id === pivotId) : null
      return matchedAd ? { ...insight, ...matchedAd } : { ...insight }
    })
  }

  // Website conversions (Insight Tag / CAPI) + Lead Gen Form submissions
  static LINKEDIN_ANALYTICS_FIELDS = 'pivotValues,dateRange,impressions,clicks,costInLocalCurrency,externalWebsitePostClickConversions,oneClickLeads'

  static getLinkedInConversions(item) {
    if(!item) {
      return 0
    }
    return (Number(item.externalWebsitePostClickConversions) || 0) + (Number(item.oneClickLeads) || 0)
  }
}